// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3BlY1","col":"styles_col__3MsVH","actions":"styles_actions__2PgGz","conflict":"styles_conflict__3FTU7"};